import React from 'react';

const VersionCheck = () => <div>{__VERSION__}</div>;

export default VersionCheck;
